import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProgressBar } from './ProgressBar';

const Login = (props) => {
    const { showProgress } = useProgressBar();
    const username = useRef('');
    const password = useRef('');
    const navigate = useNavigate();
    const[emptyusername,setusername]=useState(null);
    const[emptypassword,setpassword]=useState(null);
    const checkusernameempty = async ()=>{
        
        if(username.current.value==""){
            
            setusername(true);
        }else{
            setusername(false);
        }
    }
    const checkpasswordempty = async ()=>{
        if(password.current.value==""){
           
            setpassword(true);
        }else{
            setpassword(false);
        }
    }
    const handleButtonClick = () => {
        
        if((username.current.value=="")&&(password.current.value=="")){
            setusername(true);
            setpassword(true);
        }else if(username.current.value==""){
            setusername(true); 
        }else if(password.current.value==""){
            setpassword(true);
        }else{
            setusername(false);
            setpassword(false);
            showProgress(true);
            if (props.callParentMethod) {         
                props.callParentMethod(username.current.value.trim(), password.current.value.trim());  // Calling the parent method passed as a prop
               
            } else {
                console.log("callParentMethod is not defined");
            
        }
      }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        alert(`Username: ${username}, Password: ${password}`);
    };
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            if (document.activeElement === username.current) {
                password.current.focus(); // Move focus to the password field
            } else if (document.activeElement === password.current) {
                handleButtonClick(); // Trigger login if Enter is pressed in password field
            }
        }
    };
    
    return (
        <div>
            <div className="d-flex align-items-center justify-content-center vh-100">
                <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                    <div className="card mb-3 w-100">
                        <div className="card-body">
                            <div className="d-flex justify-content-center py-4">
                                <a href="index.html" className="logo d-flex align-items-center w-auto">
                                    <img src="assets/img/Car Chemist Logo-Main.svg" alt="Logo" style={{ height: '30px' }}  />
                                </a>
                            </div>

                            <div className="pt-4 pb-2">
                                <h5 className="card-title text-center pb-0 fs-4">Login to Your Account</h5>
                                <p className="text-center small">Enter your username & password to login</p>
                            </div>

                            <form className="row g-3 needs-validation" onSubmit={handleSubmit}>
                                <div className="col-12">
                                    <label htmlFor="yourUsername" className="form-label">Username</label>
                                    <div className="input-group has-validation">
                                        <input
                                            type="text"
                                            name="username"
                                            className="form-control"
                                            id="yourUsername"
                                            required
                                            minLength="4"
                                            ref={username}
                                            onKeyDown={handleKeyDown}
                                            onBlur={checkusernameempty}
                                        />
                                        <div className="invalid-feedback">Please enter your username.</div>
                                    </div>

                                    {emptyusername && (
                                        <div className="form-text text-danger">
                                            Please enter your username.
                                        </div>
                                    )}
                                </div>

                                <div className="col-12">
                                    <label htmlFor="yourPassword" className="form-label">Password</label>
                                    <input
                                        type="password"
                                        name="password"
                                        className="form-control"
                                        id="yourPassword"
                                        onKeyDown={handleKeyDown}
                                        required
                                        ref={password}
                                        onBlur={checkpasswordempty}
                                    />
                                    <div className="invalid-feedback">Please enter your password!</div>
                                </div>

                                {emptypassword && (
                                    <div className="form-text text-danger">
                                        Please enter your password.
                                    </div>
                                )}

                                <div className="col-12">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="remember"
                                            value="true"
                                            id="rememberMe"
                                        />
                                        <label className="form-check-label" htmlFor="rememberMe">
                                            Remember me
                                        </label>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <button
                                        className="btn btn-primary w-100"
                                        type="button"
                                        onClick={handleButtonClick}
                                    >
                                        Login
                                    </button>
                                </div>

                                <div className="col-12">
                                    <p className="small mb-0">
                                        Don't have account? <a href="pages-register.html">Create an account</a>
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Login;
